import React from "react";
import classNames from "classnames";

import { SecondaryCriteriaForm } from "@common/secondaryCriteriaForm";
import { RichTextInput } from "@common/richTextInput";
import { useLanguage } from "@common/language";
import { Props } from "./types";
import styles from "./styles.scss";

function TextFieldsForm({
  textFields,
  editTextFields,
  secondaryCriteria,
  attributesForm,
  onAttributeChange,
  disabled,
}: Props) {
  const { currentLanguage } = useLanguage();

  return (
    <div className={styles.textFieldsForm}>
      {[...textFields]
        .sort((a, b) => (a.order < b.order ? -1 : 1))
        .map((textField, index, textFields) => {
          const criteria = textField.criteriaId
            ? secondaryCriteria.find(
                ({ uuid }) => uuid === textField.criteriaId,
              )
            : undefined;

          if (criteria) {
            if (criteria.type === "richText") {
              return (
                <div
                  key={textField.criteriaId}
                  className={classNames(styles.criteriaInput, styles.fullWidth)}
                >
                  <h3 className={styles.subTitle}>
                    {criteria.labels[
                      currentLanguage as keyof typeof criteria.labels
                    ] || criteria.name}
                  </h3>
                  <RichTextInput
                    value={attributesForm[criteria.uuid] || ""}
                    isDisabled={disabled}
                    isResizable
                    input={(value) => onAttributeChange(criteria.uuid, value)}
                  />
                </div>
              );
            }

            return (
              <div
                key={textField.criteriaId}
                className={classNames(styles.criteriaInput, {
                  [styles.inline]:
                    criteria.type === "resource" ||
                    criteria.type === "link" ||
                    criteria.type === "document",
                })}
              >
                <h3 className={styles.subTitle}>
                  {criteria.labels[
                    currentLanguage as keyof typeof criteria.labels
                  ] || criteria.name}
                </h3>
                <SecondaryCriteriaForm
                  criteria={criteria}
                  value={attributesForm[criteria.uuid] || ""}
                  flexible
                  disabled={disabled}
                  submit={(value) => onAttributeChange(criteria.uuid, value)}
                />
              </div>
            );
          }

          return (
            <div key={textField.name} className={styles.input}>
              <h3 className={styles.subTitle}>{textField.name}</h3>
              <textarea
                className={styles.textarea}
                onChange={({ target }) =>
                  editTextFields([
                    ...textFields.slice(0, index),
                    {
                      ...textField,
                      value: target.value,
                    },
                    ...textFields.slice(index + 1),
                  ])
                }
              />
            </div>
          );
        })}
    </div>
  );
}

export { TextFieldsForm };
